/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import Info from 'Assets/images/pages/web-chat/info.svg';
import {
  CONSULT_ACCEPTED,
  CONSULT_FINISHED,
  CONSULT_PENDING,
  CONTEXT_MENU_CONSULT_PATIENT,
  POOL_IN_STATUS,
} from 'Constants/consults';
import useDoctor from 'Hooks/teleconsult/useDoctor';
import Space from 'Modules/Space';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import React from 'react';
import { Item } from 'semantic-ui-react';

import PersonAvatar from '../../../Sidebar/List/ChatListGroup/PersonAvatar';

import ConsultParticipantsModal from './ConsultParticipantsModal/ConsultParticipantsModal';
import styles from './UserStatus.less';

const UserStatus = ({
  consult,
  isMinimize,
  poolStatus,
  consultStatus,
  changeContextMenu,
  consultId,
}) => {
  const { data: doctorData } = useDoctor();

  const { forPatient, patient, doctor, status } = consult || {
    doctors: [],
  };

  const [openParticipantsModal, setOpenParticipantsModal] = React.useState(false);

  const doctors = consult?.doctors || [];
  const otherDoctors = doctors
    .filter(_doctor => _doctor.id !== doctorData?.id)
    .sort((a, b) => {
      const nameA = a.fullName || '';
      const nameB = b.fullName || '';
      return nameA.toLowerCase().localeCompare(nameB.toLowerCase());
    });

  const isGoingOrEndedConsult = status === CONSULT_ACCEPTED || status === CONSULT_FINISHED;

  const displayPatientName = `${patient?.fullName || `${patient?.firstName} ${patient?.lastName}`}`;

  const title =
    otherDoctors.length > 0
      ? `${displayPatientName}, ${otherDoctors.map(_doctor => _doctor.fullName).join(', ')}`
      : displayPatientName;

  const openPatientInformation = () => {
    if (isMinimize && poolStatus === POOL_IN_STATUS && consultStatus === CONSULT_PENDING) {
      return;
    }
    changeContextMenu(CONTEXT_MENU_CONSULT_PATIENT, { consultId });
  };

  const toggleParticipantsModal = () => {
    setOpenParticipantsModal(!openParticipantsModal);
  };

  return (
    <Item.Group className="user-status" style={{ maxWidth: '100%' }}>
      <Item>
        {/* <Item.Image avatar size="tiny" src={user.avatarUrl} /> */}
        <div className={classNames({ image: true, avatar: isMinimize })}>
          <PersonAvatar data={patient} />
        </div>
        <Item.Content verticalAlign="middle" className={styles.content}>
          <Item.Header
            className={styles.name}
            as={isMinimize || !isGoingOrEndedConsult ? 'span' : 'a'}
            onClick={isGoingOrEndedConsult ? toggleParticipantsModal : undefined}>
            <Space direction="horizontal" size={4}>
              <Tooltip title={title} placement="bottomLeft">
                <div
                  style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    maxWidth: '100%',
                  }}>
                  {title}
                </div>
              </Tooltip>
              {isGoingOrEndedConsult && <img src={Info} alt="info" className={styles.icon} />}
            </Space>
          </Item.Header>
          {consult?.forPatient?.id !== consult?.patient?.id && !isMinimize && (
            <Item.Description>
              <span style={{ color: '#999999' }}>Book for</span>{' '}
              <strong>{forPatient?.fullName}</strong>
            </Item.Description>
          )}
        </Item.Content>
      </Item>
      {openParticipantsModal && (
        <ConsultParticipantsModal
          onClose={toggleParticipantsModal}
          patient={patient}
          forPatient={forPatient}
          openPatientInformation={openPatientInformation}
          doctor={doctor}
          doctors={doctors}
          consult={consult}
        />
      )}
    </Item.Group>
  );
};

export default UserStatus;
